const scrollToLinks = Array.from(document.querySelectorAll('.js-scroll-to'))
const headerHeight = document.querySelector('sticky-header').offsetHeight || 0

scrollToLinks.map((link, index) => {
  link.addEventListener('click', (e) => {
    e.preventDefault()
    scrollToElement(link.getAttribute('href'))
  })
})

const scrollToElement = (elementId) => {
  const elementToScrollTo = document.querySelector(elementId)

  if (document.body.contains(elementToScrollTo)) {
    const topOffset = elementToScrollTo.offsetTop - headerHeight

    window.scroll({
      top: topOffset,
      left: 0,
      behavior: 'smooth',
    })
  }
}
